import { render, staticRenderFns } from "./AssignTeams.vue?vue&type=template&id=6bf75389"
import script from "./AssignTeams.vue?vue&type=script&lang=js"
export * from "./AssignTeams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports